<template>
  <div>
    <center>
      <h4 class='px-5 pt-5'>Félicitations, vous receverez votre profil turfiste dans quelques instant à l'adresse mail indiquée !</h4>

    </center>
    <div class="container pl-5 pt-5 pb-4">
    <p>En attendant vous pouvez consulter le site du grouoe Turfmedia: <a href="https://turfmedia.com/">turfmedia.com</a> ou l'un des  sites dédiés aux course hippiques:</p>
    <ul>
      <li> <a href="https://www.pronostic-facile.fr/"> Pronostic Facile</a> </li>
      <li> <a href="http://madeinturf.fr/"> Made In Turf</a></li>
      <li>  <a href="http://www.turf-a-cheval.fr/"> Turf A Cheval</a></li>
      <li> <a href="https://www.pronostic-hippique.fr/"> Pronostic Hippique</a></li>
    </ul>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>